/*
 * @Author: chenyan
 * @Date: 2017-12-20 14:45:10
 * @Description: website网站管理
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-02-22 17:11:17
 */

import api from '@/api/index'
import * as _ from 'lodash'

const state = {
  webSiteOverviewInfo: null, // 网站信息
  webListInfo: null,
  storeSelectOne: {
    channel: '',
    store: {}
  },
  shopDetailListInfo: null,
  tradeExportURL: '',
  preInboundData: null,
  preInboundExportURL: '',
  depositData: null,
  accountBalance: {
    currency: null
  },
  depositExportURL: '',
  tradeDetail: null,
  cancleTradeRes: null,
  confirmTradeRes: null,
  returnTradeRes: null,
  withdrawRacdList: null,
  withdrawRacdExportURL: null,
  withdrawWebsite: null,
  todayWithdraw: null,
  webtoDetail: null,
  bondDetail: null,
  vuxtradeDetail: null,
  bondInfoDetail: null,
  fundStatus: null,
  clientProperty: null
}

const mutations = {
  getWebSiteOverview(state, data) {
    state.webSiteOverviewInfo = _.cloneDeep(data)
  },
  getWebListInfo(state, data) {
    state.webListInfo = _.cloneDeep(data)
  },
  getStoreSelectOne(state, data) {
    state.storeSelectOne = _.cloneDeep(data)
  },
  getShopDetail(state, data) {
    state.shopDetailListInfo = _.cloneDeep(data)
  },
  getTradeExportURL(state, data) {
    state.tradeExportURL = _.cloneDeep(data)
  },
  getPreInboundData(state, data) {
    state.preInboundData = _.cloneDeep(data)
  },
  getPreInboundExportURL(state, data) {
    state.preInboundExportURL = _.cloneDeep(data)
  },
  getDepositData(state, data) {
    state.depositData = _.cloneDeep(data)
  },
  getAccountBalance(state, data) {
    state.accountBalance = _.cloneDeep(data)
  },
  getDepositExportURL(state, data) {
    state.depositExportURL = _.cloneDeep(data)
  },
  getTradeDetail(state, data) {
    state.tradeDetail = _.cloneDeep(data)
  },
  cancleTrade(state, data) {
    state.cancleTradeRes = _.cloneDeep(data)
  },
  confirmTrade(state, data) {
    state.confirmTradeRes = _.cloneDeep(data)
  },
  returnTrade(state, data) {
    state.returnTradeRes = data
  },
  getWithdrawRacdList(state, data) {
    state.withdrawRacdList = _.cloneDeep(data)
  },
  getWithdrawRacdExportURL(state, data) {
    state.withdrawRacdExportURL = _.cloneDeep(data)
  },
  getWithdrawWebsite(state, data) {
    state.withdrawWebsite = _.cloneDeep(data)
  },
  getTodayWithdraw(state, data) {
    state.todayWithdraw = _.cloneDeep(data)
  },
  getwebtoDetail(state, data) {
    state.webtoDetail = _.cloneDeep(data)
  },
  getbondDetail(state, data) {
    state.bondDetail = _.cloneDeep(data)
  },
  getvuxtradeDetail(state, data) {
    state.vuxtradeDetail = _.cloneDeep(data)
  },
  getFundStatus(state, data) {
    state.fundStatus = _.cloneDeep(data)
  },
  getClientProperty(state, data) {
    state.clientProperty = _.cloneDeep(data)
  }
}

const actions = {
  // 网站总揽
  getWebSiteOverview: async({ commit, state }, param) => {
    const data = await api.getWebSiteOverview()
    if (data) {
      commit('getWebSiteOverview', data)
    }
  },
  // 网站列表
  getWebListInfo: async({ commit, state }, param) => {
    const data = await api.getWebListInfo(param)
    if (data) {
      commit('getWebListInfo', data)
    }
  },
  // 网站详情
  getStoreSelectOne: async({ commit, state }, param) => {
    const data = await api.getStoreSelectOne(param)
    if (data) {
      commit('getStoreSelectOne', data)
    }
  },
  // 交易记录列表
  getShopDetail: async({ commit, state }, param) => {
    const data = await api.getShopDetail(param)
    if (data) {
      commit('getShopDetail', data)
    }
  },
  // 获取交易记录导出报表url
  getTradeExportURL: async({ commit, state }, param) => {
    const data = await api.getTradeExportURL(param)
    if (data) {
      commit('getTradeExportURL', data)
    }
  },
  // 待入账金额列表
  getPreInboundData: async({ commit, state }, param) => {
    const data = await api.getPreInboundData(param)
    if (data) {
      commit('getPreInboundData', data)
    }
  },
  // 待入账金额导出
  getPreInboundExportURL: async({ commit, state }, param) => {
    const data = await api.getPreInboundExportURL(param)
    if (data) {
      commit('getPreInboundExportURL', data)
    }
  },
  // 保证金明细列表
  getDepositData: async({ commit, state }, param) => {
    const data = await api.getDepositData(param)
    if (data) {
      commit('getDepositData', data)
    }
  },
  // 保证金明细列表导出
  getDepositExportURL: async({ commit, state }, param) => {
    const data = await api.getDepositExportURL(param)
    if (data) {
      commit('getDepositExportURL', data)
    }
  },
  // 网站管理账户余额
  getAccountBalance: async({ commit, state }, param) => {
    const data = await api.getAccountBalance(param)
    if (data) {
      commit('getAccountBalance', data)
    }

    return data
  },
  // 交易详情
  getTradeDetail: async({ commit, state }, param) => {
    const data = await api.getTradeDetail(param)

    if (data) {
      commit('getTradeDetail', data)
    }
  },
  // 取消交易
  cancleTrade: async({ commit, state }, param) => {
    const data = await api.cancleTrade(param)
    if (data) {
      commit('cancleTrade', data)
    }
  },
  // 预授权交易
  confirmTrade: async({ commit, state }, param) => {
    const data = await api.confirmTrade(param)
    if (data) {
      commit('confirmTrade', data)
    }
  },
  // 退款
  returnTrade: async({ commit, state }, param) => {
    const data = await api.returnTrade(param)
    if (data) {
      commit('returnTrade', data)
    }
  },
  // 提现记录
  getWithdrawRacdList: async({ commit, state }, param) => {
    const data = await api.getWithdrawRacdList(param)
    if (data) {
      commit('getWithdrawRacdList', data)
    }
  },
  // 提现记录导出
  getWithdrawRacdExportURL: async({ commit, state }, param) => {
    const data = await api.getWithdrawRacdExportURL(param)
    if (data) {
      commit('getWithdrawRacdExportURL', data)
    }
  },
  // 提现记录导出
  getWithdrawWebsite: async({ commit, state }, param) => {
    const data = await api.getWithdrawWebsite(param)
    if (data) {
      commit('getWithdrawWebsite', data)
    }
  },
  // 查看今日打款金额
  getTodayWithdraw: async({ commit, state }, param) => {
    const data = await api.getTodayWithdraw(param)
    if (data) {
      commit('getTodayWithdraw', data)
    }
  },
  // 存下网站信息
  getwebtoDetail: ({ commit, state }, param) => {
    commit('getwebtoDetail', param)
  },
  // 存下保证金信息
  getbondDetail: ({ commit, state }, param) => {
    commit('getbondDetail', param)
  },
  // 存下交易记录信息
  getvuxtradeDetail: ({ commit, state }, param) => {
    commit('getvuxtradeDetail', param)
  },
  // 获取所有的交易类型和交易状态
  getTransactionFundStatus: async({ commit, state }, param) => {
    const data = await api.getFundStatus(param)
    if (data) {
      commit('getFundStatus', data)
    }
  },
  // 获取商户属性
  getClientProperty: async({ commit, state }, param) => {
    const data = await api.getClientProperty(param)
    if (data) {
      const propertyValue = JSON.parse(data.propertyValue)
      commit('getClientProperty', propertyValue)
    }
  }
}
const getters = {
  webSiteOverviewInfo: (state) => state.webSiteOverviewInfo,
  webListInfo: (state) => state.webListInfo,
  storeSelectOne: (state) => state.storeSelectOne,
  shopDetailListInfo: (state) => state.shopDetailListInfo,
  tradeExportURL: (state) => state.tradeExportURL,
  preInboundData: (state) => state.preInboundData,
  preInboundExportURL: (state) => state.preInboundExportURL,
  depositData: (state) => state.depositData,
  accountBalance: (state) => state.accountBalance,
  depositExportURL: (state) => state.depositExportURL,
  tradeDetail: (state) => state.tradeDetail,
  cancleTradeRes: (state) => state.cancleTradeRes,
  confirmTradeRes: (state) => state.confirmTradeRes,
  returnTradeRes: (state) => state.returnTradeRes,
  webtoDetail: (state) => state.webtoDetail,
  fundStatus: (state) => state.fundStatus,
  clientProperty: (state) => state.clientProperty
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
